module.exports = __webpack_public_path__ + "img/uk-dining-1.dae6ffe6.png";